/**
 * This file creates base axios which can handle the network calls to The
 * the endpoing
 */

import axios from 'axios';
import Store from '@/store';

const instance = axios.create({
  // the base url can be modified to work based on environemnt
  // in the local env, it can have a different value and a different value
  // on production.
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
  method: 'post',
});

// add global interceptor
instance.interceptors.response.use(null, (error) => {
  if (typeof error === 'object') {
    const msg = 'Something went wrong';
    Store.default.dispatch('auth/setFlashMessage', { message: msg, type: 'error' });
    return;
  }
  Store.default.dispatch('auth/setFlashMessage', error);
});

// returns common params for different methods
export function baseRequestConfig() {
  return {
    token: 'Ra3drw31VPa2yax32VJu5xay69A',
    processing: 'SEQUENTIAL',
    production: 0,
  };
}

export default instance;



// WEBPACK FOOTER //
// ./src/api/base.js